import { FunctionComponent, ReactNode } from 'react';
import { withStyles } from 'vopay';
import { Title } from '@/components/UI';

import styles from './Header.module.scss';

const cn = withStyles(styles);

type HeaderProps = {
  header: ReactNode;
  description: ReactNode;
  rightArea?: ReactNode;
};

const Header: FunctionComponent<HeaderProps> = ({ header, description, rightArea }) => (
  <div className={cn('container')}>
    <div className={cn('heading')}>
      <Title level="3">{header}</Title>
      <p className={cn('description')}>{description}</p>
    </div>
    {rightArea && <div>{rightArea}</div>}
  </div>
);

export default Header;
